import { EnvironmentProviders, provideEnvironmentInitializer, Provider } from '@angular/core';
import { TitleService } from './app/title.service';
import { CameraService, FileService } from '@softline/core';
import { BrowserFileService } from '@softline/browser';
import { BrowserCameraService } from './camera/browser-camera.service';
import { GeolocationService, SOFTLINE_SERVICE_GEOLOCATION_LINK_FACTORY } from '@softline/application';
import { BrowserGeolocationService } from './geolocation/browser-geolocation.service';
import { googleGeolocationLinkFactory } from './geolocation/google-geolocation-link.factory';
import { provideTranslations } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';

export const providePlattformBrowser = (): Array<Provider | EnvironmentProviders> => {
  return [
    TitleService,
    { provide: FileService, useClass: BrowserFileService },
    { provide: CameraService, useClass: BrowserCameraService },
    { provide: GeolocationService, useClass: BrowserGeolocationService },
    {
      provide: SOFTLINE_SERVICE_GEOLOCATION_LINK_FACTORY,
      useValue: googleGeolocationLinkFactory,
    },
    provideTranslations({
      module: 'browser',
      translations: {
        de
      }
    }),
    provideEnvironmentInitializer(async () => {
      if(!navigator.storage || !navigator.storage?.persist || !navigator.storage.persisted) {
        console.debug("[BrowserPersistService] not persisting data: ", JSON.stringify({ storage: !navigator.storage, persist: !navigator?.storage?.persist, persisted: !navigator?.storage?.persisted  }));
        return;
      }

      if(await navigator.storage.persisted()) {
        console.debug("[BrowserPersistService] loginEffect: Storage will not be cleared except by explicit user action (no changes made)");
        return;
      }
      const result = await navigator.storage.persist();
      if (result) {
        console.debug("[BrowserPersistService] loginEffect: Storage will not be cleared except by explicit user action");
      } else {
        console.debug("[BrowserPersistService] loginEffect: Storage may be cleared by the UA under storage pressure.");
      }
    }),
  ]
}
